import React from 'react';
import type { TFunction } from 'i18next';

/**
 * PrimeReact DataTable body template for Module Health boolean columns.
 * Green / red dots match other RTU tables; tooltips explain the column semantics.
 */
export function createModuleHealthStatusBodyTemplate(t: TFunction) {
  return function moduleHealthStatusBodyTemplate(rowData: any, column: any) {
    const field = column.field as string;
    const value = rowData[field];
    const truthy = Boolean(value);
    const color = truthy ? 'green' : 'red';
    const icon = truthy ? 'pi-circle-on' : 'pi-circle-fill';
    const tooltip = truthy
      ? t(`rtuDetail.modules.statusIcon.${field}.positive`)
      : t(`rtuDetail.modules.statusIcon.${field}.negative`);

    return (
      <span role="img" aria-label={tooltip} title={tooltip} className="rtu-status-icon-cell">
        <i className={`pi ${icon}`} style={{ color, fontSize: '0.7rem' }} aria-hidden />
      </span>
    );
  };
}
